<template>
<v-app>
    <v-content>
        <v-row justify="center">
            <v-dialog v-model="dialog" max-width="600">
                <v-card>
                    <v-card-title class="headline">{{head_info}}</v-card-title>
                    <v-card-text>{{info}}</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" text @click="dialog_close()">Хорошо</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        
        <v-card class="mx-auto"  max-width="500" style="padding:30px; margin:30px; margin-top:10%">
            
            <v-card-text>
                  
                <h2>Восстановление пароля</h2>
                <v-form v-model="isFormValid">
                    <v-text-field
                      :color="$mainColor"
                      :value="this.$route.query.email"
                      v-if="new_password_mode"
                      :error-messages="emailErrors"
                      label="E-mail"
                      autocomplete="email"
                      disabled
                      @input="$v.email.$touch()"
                      @blur="$v.email.$touch()"
                    ></v-text-field>
                    <v-text-field
                        v-if="new_password_mode"
                        v-model="password1"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.required, rules.min, rules.has_digit,rules.has_leters]"
                        :color="$mainColor"
                        :type="show1 ? 'text' : 'password'"
                        name="input-10-1"
                        :label="passwordLabel"
                        hint="Пароль должен быть минимум 8 символов"
                        autocomplete="new-password"
                        counter
                        @click:append="show1 = !show1">
                    </v-text-field>
                    <v-text-field
                        :color="$mainColor"
                        v-else v-model="email"
                        :error-messages="emailErrors"
                        label="E-mail"
                        :loading='loading_btn'
                        required
                        @input="$v.email.$touch()"
                        @blur="$v.email.$touch()">
                    </v-text-field>
                    <v-btn
                        :color="$mainColor"
                        :loading='loading_btn'
                        v-if="new_password_mode"
                        dark
                        outlined
                        class="mr-4 mt-3"
                        :disabled="!isFormValid"
                        @click="reset_password">
                        Изменить пароль
                    </v-btn>
                    <v-btn
                        :color="$mainColor"
                        :loading='loading_btn'
                        v-else
                        dark 
                        label
                        outlined
                        class="mr-4 mt-3 "
                        @click="submit">
                        Восстановить
                    </v-btn>
                </v-form>
            </v-card-text>
        </v-card>
    </v-content>
</v-app>
</template>

<script>
import {validationMixin} from 'vuelidate';
import {required, maxLength, email} from 'vuelidate/lib/validators';
import axios from 'axios';
import { AUTH_URL } from '../../vars';
import { mapActions, mapMutations } from 'vuex';

export default {
  name: 'ResetPassword',
  mixins: [validationMixin],
  validations: {
    name: {
      required,
      maxLength: maxLength(10),
    },
    email: {
      required,
      email,
    },
    select: {
      required,
    },
    checkbox: {
      checked(val) {
        return val;
      },
    },
  },
  data: () => ({
    dialog: false,
    name: '',
    email: '',
    info: 'Status',
    isFormValid: false,
    select: null,
    password1: '',
    loading_btn: false,
    password2: '',
    show1: false,
    checkbox: false,
    model: null,
    get_url_param: {},
    date: new Date().toISOString().substr(0, 10),
    head_info: '',
    new_password_mode: false,
    password: 'Password',

    rules: {
      required: (value) => !!value || 'Required.',
      min: (v) => v.length >= 8 || 'Минимум 8 символов',
      has_digit: (v) =>  !/^[0-9]+$/.test(v) || 'Используйте минимум один ТЕКСТОВЫЙ (латинский) символ',
      has_leters: (v) =>  !/^[a-z]+$/.test(v) || 'Используйте минимум одно ЧИСЛО',
      emailMatch: () => "The email and password you entered don't match",
    },
  }),

  computed: {
    passwordLabel(){
      return 'Пароль'
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.email) errors.push('Неверный адрес электронной почты');
      if (!this.$v.email.required) errors.push('Введите адрес электронной почты');
      return errors;
    },
  },
  methods: {
    ...mapActions(['RESET_PASSWORD_LINK', 'RESET_PASSWORD']),

    dialog_close(){
      this.dialog = false; 
      location.href = '/login'
    },
    has_email() {
      const uri = window.location.href.split('?');
      let result = false;
      if (uri.length === 2) {
        const vars = uri[1].split('&');
        let tmp = '';
        vars.forEach((v) => {
          tmp = v.split('=');
          if (tmp.length === 2) {
            if (tmp[0] === 'email') result = tmp[1];
          }
        });
      }
      return result;
    },

    has_user_id() {
      const uri = window.location.href.split('?');
      let result = false;
      if (uri.length === 2) {
        const vars = uri[1].split('&');
        let tmp = '';
        vars.forEach((v) => {
          tmp = v.split('=');
          if (tmp.length === 2) {
            if (tmp[0] === 'user_id') result = true;
          }
        });
      }
      return result;
    },
    submit() {
      this.loading_btn = true
      this.RESET_PASSWORD_LINK({
        email: this.email.toLowerCase(),
        login: this.email.toLowerCase(),
        lang: 'ru',
      })
      .then((result) => {
        if(result.status > 200){
          if(result.data.detail)
            this.$messageHelper(result.data.detail == 'User not found' ? 'Пользователь с таким email не найден' : result.data.detail, 'error')
          this.loading_btn = false
        }
        else{
          this.loading_btn = false
          this.dialog = true;
          this.info = `Перейдите в свой почтовый ящик, пожалуйста, проверьте папку СПАМ: ${this.email}`;
          this.head_info = 'Готово';
          setTimeout(() => location.href = '/login', 12000)
        }
      })
      .catch((error) => {
        this.loading_btn = false
        this.dialog = true;
        this.$messageHelper('Произошла ошибка', 'error', 3000)
        this.head_info = 'ошибка';
        this.info = `Произошла ошибка`;
      });
    },

    async reset_password() {
      this.get_url_param = this.$route.query;
      this.get_url_param.password = this.password1;
      
      await this.RESET_PASSWORD(this.get_url_param)
      .then((result) => {
        if(result.status > 200){
          if(result.data && result.data.length > 0)
           this.$messageHelper(result.data.toString(), 'error')
          this.loading_btn = false
        }
        else{
          this.dialog = true;
          this.info = `Пароль успешно изменен:${result.data.detail}`;
          this.head_info = 'Все отлично';
        }
      })
      .catch((error) => {
        this.dialog = true;
        this.$messageHelper('Произошла ошибка', 'error', 3000)
        this.head_info = 'ошибка';
        this.info = `Произошла ошибка, сообщите код 14312 в чат`;
      });
    },

    clear() {
      this.$v.$reset();
      this.name = '';
      this.email = '';
      this.select = null;
      this.checkbox = false;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
  },
  watch:{
  },
  mounted() {
    if (this.has_user_id())
      this.new_password_mode = true;
    var if_email = this.has_email();
    if (if_email) 
      this.email = if_email.replace('%40','@');
  }
};
</script>
